export const checkParitySuccess = (value: string): boolean => {
  return value.includes('_start_') && value.includes('_end_');
};

export const removeParity = (value: string): string => {
  return value.substring(value.indexOf('_start_') + 7, value.indexOf('_end_'));
};
